<template>
	<div id="cloudCenter">
		<heads></heads>
		<div class="left_t">
			<div>
				<div class="modular_title modular_title_lw">
					<img src="../../assets/tit_icon.png" />
					<div>
						
						进度计划
					</div>
				</div>
				<div class="startEnd_box">
					<div>计划开始：{{fourDate.planStart?fourDate.planStart:'-- / --'}}</div>
					<div>计划结束：{{fourDate.planEnd?fourDate.planEnd:'-- / --'}}</div>
					<div>实际开始：{{fourDate.actualStart?fourDate.actualStart:'-- / --'}}</div>
					<div>实际结束：{{fourDate.actualEnd?fourDate.actualEnd:'-- / --'}}</div>
				</div>
				<div class="asktime_box">
					<div class="ask_time_box">
						<img src="../../assets/jindu/speed_time.png" />
						<div>要求工期：</div>
						<div class="ask_time">{{speeddata.requirement>0?speeddata.requirement:'--'}} 天</div>
					</div>
					<div class="ask_line"></div>
					<div class="ask_time_box">
						<img src="../../assets/jindu/speed_time.png" />
						<div>已执行工期：</div>
						<div class="ask_time">{{speeddata.already>0?speeddata.already:'--'}} 天</div>
					</div>
					<div class="ask_line"></div>
					<div class="ask_time_box">
						<img src="../../assets/jindu/speed_time.png" />
						<div>剩余工期：</div>
						<div class="ask_time">{{speeddata.surplus>0?speeddata.surplus:'--'}} 天</div>
					</div>
					<div class="ask_line"></div>
					<div class="ask_time_box">
						<img src="../../assets/jindu/speed_time.png" />
						<div>工期状态：</div>
						<div class="ask_time">{{speeddata.status?speeddata.status:'--'}}</div>
					</div>
				</div>
				<img class="division" src="../../assets/jindu/division.png" />
				<div class="schedule">
					<schedule></schedule>
				</div>
			</div>
		</div>
		<div class="right">
			<div class="right_t">
				<div class="modular_title modular_title_lw">
					<img src="../../assets/tit_icon.png" />
					<div>
						
						工程进度
					</div>
				</div>
				<div class="speed">
					<div class="project_date">
						<div class="pro_time">项目时长</div>
						<div class="pro_num">{{progressInfo.allDate}}</div>
					</div>
					<ul class="tuglie">
						<li>
							<div class="circular tuglie_1"></div>
							<div>未开始</div>
						</li>
						<li>
							<div class="circular tuglie_2"></div>
							<div>进行中</div>
						</li>
						<li>
							<div class="circular tuglie_3"></div>
							<div>按时完成</div>
						</li>
						<li>
							<div class="circular tuglie_4"></div>
							<div>超期</div>
						</li>
					</ul>
					<div class="speen_btn" v-if="speed.length>0">
						<img class="speedline" src="../../assets/speedline.png" />
						<img class="syleft" src="../../assets/s_l.png" />
						<img class="syright" src="../../assets/s_r.png" />
						<swiper :options="swiperOption" ref="mySwiper">
							<swiper-slide v-for="(data,index) in speed" :key="index+321">
								<ul class="speed_con_box">
									<li v-for="item in data" :key="item.name">
										<div v-if="$store.state.bgClass=='bgClass_1'">
											<img v-if="item.status==1" class="wcicon" src="../../assets/blue_1.png">
											<img v-else-if="item.status==2" class="wcicon" src="../../assets/sky_1.png">
											<img v-else-if="item.status==3" class="wcicon" src="../../assets/green_1.png">
											<img v-else-if="item.status==4" class="wcicon" src="../../assets/yellow_1.png">
										</div>
										<div v-else-if="$store.state.bgClass=='bgClass_2'">
											<img v-if="item.status==1" class="wcicon" src="../../assets/zi_2.png">
											<img v-else-if="item.status==2" class="wcicon" src="../../assets/lan_2.png">
											<img v-else-if="item.status==3" class="wcicon" src="../../assets/lan_2.png">
											<img v-else-if="item.status==4" class="wcicon" src="../../assets/hong_2.png">
										</div>
										<div v-else-if="$store.state.bgClass=='bgClass_3'">
											<img v-if="item.status==1" class="wcicon" src="../../assets/zi_3.png">
											<img v-else-if="item.status==2" class="wcicon" src="../../assets/lan_3.png">
											<img v-else-if="item.status==3" class="wcicon" src="../../assets/lv_2.png">
											<img v-else-if="item.status==4" class="wcicon" src="../../assets/huang_3.png">
										</div>
										<el-tooltip :content="item.name" placement="top" effect="light">
											<div class="speedcon">
												<div class="speedcondata">{{ item.name }}</div>
												<div>{{ item.planStartDate }}</div>
											</div>
										</el-tooltip>
									</li>
								</ul>
							</swiper-slide>
						</swiper>
					</div>
					<div class="zwsj" v-if='speed.length==0' style="margin-top: 60px;">
							暂无数据
						</div>
				</div>
			</div>
			<div class="right_b">
				<div class="modular_title modular_title_lw">
					<img src="../../assets/tit_icon.png" />
					<div>
						每日填报日志
						
					</div>
				</div>
				<div class="journal">
					 <div class="journal_tit">
						<div style="width: 10%;">序号</div>
						<div style="width: 25%;">任务名称</div>
						<div style="width: 20%;">种类</div>
						<div style="width: 15%;">当日完成量</div>
						<div style="width: 10%;">单位</div>
						<div style="width: 20%;">日期</div>
					</div>
					<div class="wjcontent">
						<div @click.stop="downfile(index)" class="list" v-for="(item,index) in wjlist">
							<div class="wjline" :class="currentIndex==index?'activewjline':''"></div>
							<div class="wjcon" :class="currentIndex==index?'activewjcon':''">
								<div style="width: 10%;">{{index+1}}</div>
								<div style="width: 25%;">{{item.name}}</div>
								<div style="width: 20%;">{{item.typeName}}</div>
								<div style="width: 15%;">{{item.dayFinish}}</div>
								<div style="width: 10%;">{{item.unit}}</div>
								<div style="width: 20%;color: #B1CBF6;">{{item.dayDate}}</div>
							</div>
							<div class="wjline"></div>
						</div>
						<div class="zwsj" v-if='wjlist.length==0'>
							暂无数据
						</div>
					</div> 
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import heads from "@/components/header.vue"
	import schedule from "./components/Schedule.vue"
	import { swiper, swiperSlide } from "vue-awesome-swiper";
	import "swiper/dist/css/swiper.css";
	export default {
		data() {
			return {
				colorlists: [],
				//swiper 初始化
				swiperOption: {
					navigation: {
						prevEl: '.syleft',
						nextEl: '.syright'
					}
				},
				speed: [],
				progressInfo:{},
				wjlist: [],
				currentIndex: -1,
				speeddata:{
					requirement:'',
					already:'',
					surplus:'',
					status:''
				},
				fourDate:{
					planStart:'',
					planEnd:'',
					actualStart:'',
					actualEnd:''
				}
			}
		},
		components: {
			heads,
			schedule,
			swiper,
			swiperSlide
		},
		created(){
			this.randomRgb()
			this.getspeed()

			//每日填报
			this.getDdayFillin()
		},
		mounted() {

			//工程进度
			this.selectProgress()
			this.resetScreenSize()
		},
		methods: {
			getspeed(){
				this.postAxios('/build/progressPlanDaPingShow/selectMapForDaPingShowProgress', {1:1},'json').then(res => {
					this.speeddata.requirement=res.data.data.upDate.要求工期
					this.speeddata.already=res.data.data.upDate.已执行工期
					this.speeddata.surplus=res.data.data.upDate.剩余工期
					this.speeddata.status=res.data.data.upDate.工期状态

					this.fourDate.planStart=res.data.data.upDate.计划开始
					this.fourDate.planEnd=res.data.data.upDate.计划结束
					this.fourDate.actualStart=res.data.data.upDate.实际开始
					this.fourDate.actualEnd=res.data.data.upDate.实际结束

				}).catch(err => {})
			},
			randomRgb() {
				for (let i=0;i<1000;i++) {
					let R = Math.floor(Math.random() * 255);
					let G = Math.floor(Math.random() * 255);
					let B = Math.floor(Math.random() * 255);

						this.colorlists.push('rgb(' + R + ',' + G + ',' + B + ')')

					
				}
				
			},
			downfile(index) {
				this.currentIndex = index
			},
			//工程进度
			selectProgress() {
				this.postAxios('/build/progressPlanManageDetails/selectPlanLastTimeSHOUYE').then(res => {
					this.speed = res.data.data.ZIB
					this.progressInfo = res.data.data.ZUB
					var list = []
					//一次显示几个个
					for(var i = 0; i < this.speed.length; i += 5) {
						list.push(this.speed.slice(i, i + 5));
					}
					this.speed = []
					for(var j = 0; j < list.length; j++) {
						this.speed.push(list[j])
					}
				}).catch(err => {})

			},

			//每日填报日志
			getDdayFillin(){
				this.postAxios('/build/progressPlanDaPingShow/selectByMapForDaPing', {1:1},'json').then(res => {

					this.wjlist = res.data.data
					

				}).catch(err => {})
			},
			resetScreenSize(dw, dh) {
				if(window.innerWidth > 1000) {
					function init() {
						var _el = document.getElementById('cloudCenter');
						var hScale = window.innerHeight / (dh || 1080);
						var wScale = window.innerWidth / (dw || 1920);
						_el.style.transform = 'scaleX(' + wScale + ') scaleY(' + hScale + ')'
					}
					var lazyFun;
					window.onresize = function() {
						clearTimeout(lazyFun);
						lazyFun = setTimeout(function() {
							init()
						}, 600)
					}
					init()
				}
			}

		}
	}
</script>

<style scoped>
	@import "./index.css";
	#cloudCenter {
		width: 1920px;
		height: 1080px;
		transform-origin: left top;
		position: relative;
	}
	/*左边*/
	
	.bgClass_1 .left_t {
		background: url(../../assets/jindu/left_bg1.png) no-repeat;
		background-size:100% 100% ;
	}
	
	.bgClass_2 .left_t {
		background: url(../../assets/jindu/left_bg2.png) no-repeat;
		background-size:100% 100% ;
	}
	
	.bgClass_3 .left_t {
		background: url(../../assets/jindu/left_bg3.png) no-repeat;
		background-size:100% 100% ;
	}
	/*左边*/
	.modular_title {
		display: flex;		
		padding: 0 10px 0 20px;		
		align-items: center;		
		font-size: 22px;
		color: #FFFFFF;		
		line-height: 52px;
	}	
	.modular_title div{
		height: 52px;
		display: inline-block;
		background: url(../../assets/tit_bg.png) no-repeat center bottom;
		background-size:100% 17px;
	}	
	.modular_title img {
		margin-right: 9px;
		vertical-align: middle;
	}
	
	.left_t {
		float: left;
		height: 913px;
		width: 948px;
		margin-top: 10px;
		margin-left: 31px;
		position: relative;
	}
	
	.startEnd_box {
		width: 426px;
		position: absolute;
		right: 39px;
		top: 24px;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	
	.startEnd_box div {
		width: 165px;
		height: 24px;
		background: url(../../assets/jindu/startend_bg.png) no-repeat;
		padding-left: 21px;
		color: #FFFFFF;
		font-size: 14px;
		line-height: 24px;
		margin-bottom: 31px;
	}
	
	.asktime_box {
		display: flex;
		align-items: center;
		justify-content: space-around;
		width: 852px;
		margin: 0 auto;
		margin-top: 77px;
	}
	
	.ask_time_box {
		display: flex;
		align-items: center;
		color: #FFFFFF;
		font-size: 14px;
	}
	
	.ask_time_box img {
		margin-right: 4px;
	}
	
	.ask_time {
		color: #FBE56B;
		font-size: 24px;
		margin-left: 20px;
	}
	
	.ask_line {
		width: 2px;
		height: 28px;
		background: #A3E9FC;
	}
	
	.division {
		display: block;
		margin: 0 auto;
		margin-top: 20px;
	}
	
	.schedule {
		height: 720px;
	}
	
	.right {
		float: left;
		margin-left: 20px;
	}
	
	.right_t {
		width: 877px;
		height: 292px;
		margin-top: 10px;
	}
	
	.right_b {
		width: 877px;
		height: 601px;
		margin-top: 19px;
	}
	/*工程进度*/
	
	.speed {
		height: 242px;
		width: 810px;
		margin: 0 auto;
		position: relative;
		overflow: hidden;
	}
	
	.project_date {
		display: flex;
		align-items: center;
		position: absolute;
		width: 200px;
		transform: translateX(-50%);
		left: 50%;
	}
	
	.tuglie {
		float: right;
		margin-top: 6px;
	}
	
	.tuglie li {
		float: left;
		list-style-type: none;
		margin-left: 22px;
		color: #FFFFFF;
		font-size: 12px;
		display: flex;
		align-items: center;
	}
	
	.circular {
		height: 9px;
		width: 9px;
		border-radius: 50%;
		margin-right: 6px;
	}
	
	.pro_time {
		color: #FBE56B;
		font-size: 18px;
	}
	
	.pro_num {
		color: #FFFFFF;
		font-size: 18px;
		margin-left: 6px;
	}
	
	.wcicon {
		width: 74px;
		height: 74px;
	}
	
	.speen_btn {
		height: 180px;
		width: 786px;
		position: relative;
		margin: 0 auto;
		margin-top: 40px;
	}
	
	.syleft {
		position: absolute;
		top: 20px;
		left: -10px;
		z-index: 99;
	}
	
	.syright {
		position: absolute;
		top: 20px;
		right: -10px;
		z-index: 99;
	}
	
	.speedline {
		position: absolute;
		top: 32px;
	}
	
	.speed_con_box {
		width: 100%;
		height: 190px;
	}
	
	.speed_con_box li {
		width: 152px;
		text-align: center;
		float: left;
		margin-right: 6px;
	}
	
	.speed_con_box li:last-child {
		margin-right: 0;
	}
	
	.speedcon {
		height: 68px;
		width: 152px;
		color: #FFFFFF;
		margin-top: 12px;
		font-size: 16px;
		overflow: hidden;
	}
	
	.speedcondata {
		display: inline-block;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-top: 13px;
		margin-bottom: 5px;
	}
	
	.journal {
		height: 518px;
		overflow: auto;
		overflow-x: hidden;
	}
	.journal::-webkit-scrollbar {
		  display: none; /* Chrome Safari */
		}
		
		.journal {
		  scrollbar-width: none; /* firefox */
		  -ms-overflow-style: none; /* IE 10+ */
		  overflow-x: hidden;
		  overflow-y: auto;
		}
	.journal_tit {
		color: #FBE56B;
		font-size: 16px;
		justify-content: space-between;
		margin: 0 auto;
		height: 58px;
		width: 793px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #A3E9FC;
	}
	
	.journal_tit div{
		text-align: center;
	}
	
	.list {
		margin: 0 auto;
		display: flex;
		width: 827px;
		align-items: center;
		justify-content: space-between;
	}
	
	.wjcon {
		width: 793px;
		height: 46px;
		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
		display: flex;
		align-content: center;
		
	}
	.wjcon div{
		color: #FFFFFF;
		font-size: 16px;
		text-align: center;
		line-height: 46px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space:nowrap;
	}
	
	.activewjcon {
		box-sizing: content-box;
		background: rgba(67, 117, 223, 0.1);
		border: 1px solid #305FC5;
	}
	
	.wjneirong {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-left: 8px;
	}
	
	.wjkuang {
		width: 9px;
		height: 8px;
		margin-right: 10px;
	}
	
	.wjtit {
		color: #FFFFFF;
		font-size: 16px;
	}
	
	.wjtime {
		color: #B1CBF6;
		font-size: 16px;
		display: flex;
		align-items: center;
		margin-right: 28px;
	}
	
	.wjline {
		width: 7px;
		height: 33px;
	}
	
	.activewjline {
		background: #A3E9FC;
	}
	
	.activeWjLine {
		background: #A3E9FC;
	}
	.zwsj{
		font-size: 12px;
		text-align: center;
		margin-top: 12px;
		color: #CCCCCC;
	}
	
</style>